import {
  BE_CALL_ALERTING,
  BE_CALL_ANSWERED,
  BE_HOLD_CALL,
  BE_END_CALL,
  BE_RETRIEVE_CALL,
  FE_RINGING,
  FE_ANSWERED,
  FE_ON_HOLD,
  FE_RELEASED,
} from '@rsos/constants/callStatuses';

/**
 * Get call status display name based on call status value from backend.
 * @param {String} status - ALI 911 event call status
 * @returns String
 */
export const getCallStatusName = status => {
  switch (status) {
    case BE_CALL_ALERTING:
      return FE_RINGING;
    case BE_CALL_ANSWERED:
      return FE_ANSWERED;
    case BE_HOLD_CALL:
      return FE_ON_HOLD;
    case BE_END_CALL:
      return FE_RELEASED;
    case BE_RETRIEVE_CALL:
      return FE_ANSWERED;
    default:
      return null;
  }
};

/**
 * Get call status theme colors based on call status value from backend.
 * @param {String} status - ALI 911 event call status
 * @param {Boolean} isBGColor - Get the background or the text color of the call status
 * @returns String
 */
export const getCallStatusColor = (status, isBGColor) => {
  switch (status) {
    case BE_CALL_ALERTING:
      return `tag.warning.${isBGColor ? 'bg' : 'text'}`;
    case BE_CALL_ANSWERED:
      return `tag.success.${isBGColor ? 'bg' : 'text'}`;
    case BE_HOLD_CALL:
      return `tag.caution.${isBGColor ? 'bg' : 'text'}`;
    case BE_END_CALL:
      return `tag.secondary.${isBGColor ? 'bg' : 'text'}`;
    case BE_RETRIEVE_CALL:
      return `tag.success.${isBGColor ? 'bg' : 'text'}`;
    default:
      return `tag.secondary.${isBGColor ? 'bg' : 'text'}`;
  }
};
